import { useZionAxios } from '@fs/zion-axios'

export const useGroupLimitsCall = () => {
  return useZionAxios('/service/tree/tree-data/groups/limits')
}
